import * as React from 'react';
import { useSelector } from 'react-redux';
import { AddButton } from '../../components/AddButton';
import { selectSavedInFolders, selectSavedOfferId, selectUserHasFolders } from '../../selectors';
import { ChangeFolderButtonContainer } from '../ChangeFolderButtonContainer';
import { CreateFolderButtonContainer } from '../CreateFolderButtonContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonContainer = function ButtonContainer(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
    onWaitForLogin = _ref.onWaitForLogin;
  var offerIds = useSelector(selectSavedOfferId);
  var savedInFolders = useSelector(selectSavedInFolders);
  var userHasFolders = useSelector(selectUserHasFolders);
  var handleNotAuthenticatedSaveToFolder = React.useCallback(function () {
    if (onWaitForLogin) {
      onWaitForLogin();
    }
  }, [onWaitForLogin]);
  if (offerIds.length <= 1 && !isAuthenticated) {
    return /*#__PURE__*/_jsx(AddButton, {
      text: "\u0421\u043E\u0445\u0440. \u0432 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443",
      showIcon: true,
      onClick: handleNotAuthenticatedSaveToFolder
    });
  } else if (offerIds.length <= 1 && !savedInFolders && !userHasFolders) {
    return /*#__PURE__*/_jsx(CreateFolderButtonContainer, {
      showIcon: true
    });
  } else if (offerIds.length <= 1) {
    return /*#__PURE__*/_jsx(ChangeFolderButtonContainer, {
      showIcon: true
    });
  }
  return null;
};